import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  ZIP_CODE_RANGE_OPERATOR,
  type ShippingLocation as ShippingLocationType,
} from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

const { INCLUDE, EXCLUDE } = ZIP_CODE_RANGE_OPERATOR

type ShippingLocationProps = {
  shippingLocation: ShippingLocationType | undefined
}

export function ShippingLocation(props: ShippingLocationProps) {
  const { $t, formatList } = useIntl()
  const { shippingLocation } = props

  if (!shippingLocation) return

  const { shippingCountries, zipCodeRanges } = shippingLocation

  const inclusiveZipCodeRanges = zipCodeRanges.filter(
    (range) => range.operator === INCLUDE
  )

  const exclusiveZipCodeRanges = zipCodeRanges.filter(
    (range) => range.operator === EXCLUDE
  )

  const shippingCountriesTooltip = shippingCountries.length
    ? $t(messages.shippingLocation.tooltip.countries, {
        list: formatList(shippingCountries, { type: 'disjunction' }),
      })
    : undefined

  const inclusiveZipCodeRangesTooltip = inclusiveZipCodeRanges.length
    ? $t(messages.shippingLocation.tooltip.zipCode, {
        include: true,
        list: formatList(
          inclusiveZipCodeRanges.map(({ from, to }) => formatList([from, to])),
          { type: 'disjunction' }
        ),
      })
    : undefined

  const exclusiveZipCodeRangesTooltip = exclusiveZipCodeRanges.length
    ? $t(messages.shippingLocation.tooltip.zipCode, {
        include: false,
        list: formatList(
          exclusiveZipCodeRanges.map(({ from, to }) => formatList([from, to])),
          { type: 'disjunction' }
        ),
      })
    : undefined

  const tooltipContent =
    formatList(
      [
        shippingCountriesTooltip,
        inclusiveZipCodeRangesTooltip,
        exclusiveZipCodeRangesTooltip,
      ].filter((x) => x !== undefined)
    ) ?? ''

  return (
    <Tooltip text={tooltipContent}>
      <Tag>
        <FormattedMessage {...messages.shippingLocation.title} />
      </Tag>
    </Tooltip>
  )
}
